<template>
  <div class="answer-section">
    <div class="container">
      <div class="answer-content">
        <div class="answer-column">
          <div v-for="(item,index) in list" :key="index" @click="handleClick(item)">
            <div class="u-flex u-row-between">
              <div class="answer-item">
                <span :class="index==0?'first-item':index==1?'second-item':index==2?'third-item':'other-item'">{{ index+1 }}</span> {{ item.title }}
              </div>
              <div class="u-font-14 cl_666">{{ new Date(item.create_time*1000).toLocaleString() }}</div>
            </div>
            <el-divider v-if="index<list.length-1"></el-divider>
          </div>
          <el-empty :image-size="200" v-if="list.length === 0"></el-empty>
        </div>
      </div>
      <!-- 分页 -->
        <div class="u-flex u-row-center u-m-t-60" v-if="list.length !== 0">
            <el-pagination
              layout="prev, pager, next"
              background
              :total="records"
              :current-page.sync="page"
              :page-size.sync="limit"
              @current-change="getlist"
              @size-change="getlist"
            />
        </div>
    </div>
  </div>
</template>

<script>
import { evaluateAnswer } from '@/api/index'

export default {
  data() {
    return {
       // 可以在这里添加数据
      list: [],
      records: 0,
      page: 1,
      limit: 10,
    }
  },
  mounted() {
    this.getlist()
  },
  methods: {
    getlist() {
      evaluateAnswer({
        page: this.page,
        limit: this.limit
      }).then(res => {
        if (res.code === 1) {
          this.list = res.data.list
          this.records = res.data.total
        }
      })
    },
    handleClick(item) {
      this.$router.push({
        path: '/answerDetails',
        query: {
          id: item.id
        }
      })
    }
  }
}
</script>

<style scoped>
.answer-section{
  padding: 60px 0;
}
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.answer-content{
  background: #fff;
  padding: 40px;
  border-radius: 8px;
  box-shadow: 0px 3px 8px 1px rgba(60,97,135,0.05);
}
.answer-column {
  flex: 1;
  display: flex;
  flex-direction: column;
  /* gap: 8px; */
}

.answer-item {
  font-size: 14px;
  color: #333;
  line-height: 32px;
  cursor: pointer;
  transition: color 0.3s;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.answer-item:hover {
  color: #0066cc;
}
.first-item {
  font-size: 14px;
  color: #FF0B34;
  font-weight: 600;
}
.second-item {
  font-size: 14px;
  color: #FF6600;
  font-weight: 600;
}
.third-item {
  font-size: 14px;
  color: #FCC633;
  font-weight: 600;
}
.other-item {
  font-size: 14px;
  color: #999;
  font-weight: 600;
}
</style>